import Component from '@glimmer/component';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { installDropdown } from 'mewe/utils/dropdown-utils';

import dispatcher from 'mewe/dispatcher';
import { inject as service } from '@ember/service';

export default class SidebarLeftGroup extends Component {
  @service dynamicDialogs;

  @tracked dropdownOptions;

  constructor() {
    super(...arguments);
    installDropdown(this, 'dropdownOptions');
  }

  @action
  openReportGroupDialog() {
    dispatcher.dispatch('group', 'reportGroup', { group: this.args.groupModel });
  }

  @action
  openGroupCreationDialog() {
    this.dynamicDialogs.openDialog('create-group-dialog');
  }
}
